import CaseSide from './CaseSide';

export default CaseSide;
